// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3utJm","largestCol":"styles_largestCol__2Piwg","smallestCol":"styles_smallestCol__1KquY"};